// Generated file: Do not edit 
// generated from @taqueria-protocol-types
    
import { TaqError, toFutureParseErr, toFutureParseUnknownErr, toParseErr, toParseUnknownErr } from '@taqueria/protocol/TaqError';
import { FutureInstance, resolve, reject } from 'fluture';
import { ZodError } from 'zod';
import { ConfigEnvironmentFileV2 } from '@taqueria/protocol/types';
import { ConfigEnvironmentFileV2 as ConfigEnvironmentFileV2Strict } from '@taqueria/protocol/out/types-strict';
import { configEnvironmentFileV2Schema } from '@taqueria/protocol/out/types-zod';

export type { ConfigEnvironmentFileV2Strict as ConfigEnvironmentFileV2 };

export const from = (input: unknown): ConfigEnvironmentFileV2Strict => {
	try {
		return configEnvironmentFileV2Schema.parse(input) as ConfigEnvironmentFileV2Strict;
	}
	catch (previous: unknown) {
		if (previous instanceof ZodError) {
			const msgs: string[] = previous.errors.reduce(
				(retval, issue) => {
					const path = issue.path.join(' → ');
					const msg = path + ': ' + issue.message;
					return [...retval, msg];
				},
				["ConfigEnvironmentFileV2 is invalid:"],
			);
			const validationErr = msgs.join('\n') + '\n';
			throw toParseErr(previous, validationErr);
		}
		throw toParseUnknownErr(previous, "There was a problem trying to parse a ConfigEnvironmentFileV2.")
	}
    
};

export const create = (input: ConfigEnvironmentFileV2): ConfigEnvironmentFileV2Strict => from(input);

export const of = (input: unknown): FutureInstance<TaqError, ConfigEnvironmentFileV2Strict> => {
	try {
		return resolve(from(input))
	}
	catch (err){
		return reject(err) as FutureInstance<TaqError, never>
	}
};

export const make = (input: Omit<ConfigEnvironmentFileV2Strict, '__type'>): FutureInstance<TaqError, ConfigEnvironmentFileV2Strict> => of(input);

// TEMP: for interoperation with old protocol types during transition
export const schemas = {
	rawSchema: configEnvironmentFileV2Schema,
	schema: configEnvironmentFileV2Schema.transform(val => val as ConfigEnvironmentFileV2Strict),
};
export const rawSchema = schemas.rawSchema;
export const internalSchema = configEnvironmentFileV2Schema;

export type t = ConfigEnvironmentFileV2Strict;
        